import { createSlice } from "@reduxjs/toolkit";
import { PhaseEventType } from "../../data-entry/models/eaf.models";

const CatalogPhaseEventsInitialState: {
	phaseEvents: PhaseEventType[] | null;
} = {
	phaseEvents: null,
};

export const CatalogPhaseEventsReducer = createSlice({
	name: "__",
	initialState: CatalogPhaseEventsInitialState,
	reducers: {
		setPhaseEvents(state, { payload }) {
			state.phaseEvents = payload;
		},
	},
});
